import Vue from 'vue'
import i18n from '@/i18n'
 
Vue.prototype.copyAll = (txt) => {
	if(!txt) return ''
	uni.setClipboardData({ 
	    data: txt,  
	    success: function () { 
	        // 设置成功 
			uni.showToast({
				title:i18n.t('common.copySuccess')
			})
	    },  
	    fail: function () {
	        // 设置失败 
			uni.showToast({
				title:i18n.t('content.copyFailed')
			})
	    } 
	});
}
Vue.filter('date', (timeStamp, format)=>{
	if(!timeStamp) return '';

	if('' + timeStamp.length <= 10){
		timeStamp = + timeStamp * 1000;
	}else{
		timeStamp = + timeStamp;
	}
	let _date = new Date(timeStamp),
		Y = _date.getFullYear(),
		m = _date.getMonth() + 1,
		d = _date.getDate(),
		H = _date.getHours(),
		i = _date.getMinutes(),
		s = _date.getSeconds();
	
	m = m < 10 ? '0' + m : m;
	d = d < 10 ? '0' + d : d;
	H = H < 10 ? '0' + H : H;
	i = i < 10 ? '0' + i : i;
	s = s < 10 ? '0' + s : s;

	return format.replace(/[YmdHis]/g, key=>{
		return {Y,m,d,H,i,s}[key];
	});
})

Vue.filter('shot', (txt)=>{
	if(!txt) return '';
	return txt.substr(0,4)+'****'+txt.substr(txt.length-4)
})
Vue.filter('getName', (id, data)=>{
	let arr=data.filter(item=>item.id==id)
	return arr[0]&& arr[0].name||''
})
Vue.filter('price', (amount, fixed=2)=>{
	if(!amount || isNaN(amount)){
		return 0
	}
	const parts = parseFloat(amount).toFixed(fixed).split('.');
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	return `${parts.join('.')}`;
	//return fixed > 0 ? parseFloat(price).toFixed(fixed) : + parseFloat(price).toFixed(2);
})
 
Vue.filter('timeDiff', (seconds)=>{
    if (!seconds ||seconds<0) return seconds;
  
    const UNITS = [
      { label: i18n.t('content.month'), value: 30 * 24 * 60 * 60 }, // 1月 = 30天
      { label: i18n.t('content.day'), value: 24 * 60 * 60 },      // 1天 = 24小时
      { label: i18n.t('content.hour'), value: 60 * 60 },         // 1小时 = 60分钟
      { label: i18n.t('content.minute'), value: 60 },                // 1分 = 60秒
      { label: i18n.t('content.second'), value: 1 }                  // 秒
    ];
  
    let result = "";
  
    for (const { label, value } of UNITS) {
      const unitAmount = Math.floor(seconds / value);
      if (unitAmount > 0 || (value === 1 && result === "")) {
        result += `${unitAmount}${label}`;
      }
      seconds %= value;
    }
  
    return result;
})
Vue.filter('dateDiff', (timestamp) => {
  if (!timestamp || timestamp < 0) return timestamp;

  const now = Date.now(); // 当前时间戳（毫秒）
  let milliseconds = Math.abs(now - timestamp); // 计算时间差（毫秒）

  const UNITS = [
    { label: i18n.t('content.month'), value: 30 * 24 * 60 * 60 * 1000 }, // 1月 = 30天（毫秒）
    { label: i18n.t('content.day'), value: 24 * 60 * 60 * 1000 },      // 1天 = 24小时（毫秒）
    { label: i18n.t('content.hour'), value: 60 * 60 * 1000 },         // 1小时 = 60分钟（毫秒）
    { label: i18n.t('content.minute'), value: 60 * 1000 },                // 1分 = 60秒（毫秒）
    { label: i18n.t('content.second'), value: 1000 }                      // 秒（毫秒）
  ];

  let result = "";

  for (const { label, value } of UNITS) {
    const unitAmount = Math.floor(milliseconds / value);
    if (unitAmount > 0 || (value === 1000 && result === "")) {
      result += `${unitAmount}${label}`;
    }
    milliseconds %= value;
  }

  return result;
});
